import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function FailedSolutions() {
  return <section className="py-12 md:py-20 px-4 md:px-6 bg-[var(--bg-deep)]" data-id="element-95">
      <div className="max-w-[720px] mx-auto" data-id="element-96">
        <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] mb-6 md:mb-10 text-center leading-tight" data-id="element-97">
          You aren't just dealing with a{' '}
          <span className="text-[var(--accent)] italic" data-id="element-98">"picky eater."</span>
        </h2>

        <div className="space-y-5 md:space-y-6 text-base md:text-lg text-[var(--text-primary)] leading-relaxed" data-id="element-99">
          <p className="text-lg md:text-xl font-medium text-[var(--text-heading)]" data-id="element-100">
            You are dealing with a child whose brain perceives a piece of
            broccoli as a physical threat.
          </p>

          <p data-id="element-101">
            To them, that new texture feels like swallowing slime, or needles,
            or sand.
          </p>

          <div className="mt-8 mb-6" data-id="element-102">
            <p className="text-[var(--text-muted)] font-bold uppercase tracking-widest text-sm mb-4" data-id="element-103">
              The Result?
            </p>
            <div className="grid gap-3 md:gap-4" data-id="element-104">
              {[{
              title: 'Meltdowns',
              desc: 'That leave you and your child sobbing at the dinner table.'
            }, {
              title: 'The "Nugget Cage"',
              desc: 'Feeling trapped by the same 3 white foods every single day.'
            }, {
              title: 'Health Anxiety',
              desc: "Checking their fingernails and hair, terrified they aren't getting the nutrients they need to grow."
            }, {
              title: 'Social Isolation',
              desc: 'Declining birthday parties and family dinners because the food "won\'t be safe."'
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-4 p-4 md:p-5 bg-[var(--bg-card)] rounded-xl border border-[var(--border-subtle)] shadow-sm" data-id="element-105">
                  <AlertCircle className="w-5 h-5 text-[var(--red-emphasis)] flex-shrink-0 mt-0.5" data-id="element-106" />
                  <div data-id="element-107">
                    <strong className="text-[var(--text-heading)] block mb-1" data-id="element-108">
                      {item.title}
                    </strong>
                    <p className="text-[var(--text-muted)] text-sm md:text-base" data-id="element-109">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}